
import styled from 'styled-components';

const ReportsWrapper = styled.div`

`;

export default ReportsWrapper;


// WEBPACK FOOTER //
// ./src/components/Box/Reports/Reports.style.js